import axios from "axios";
import { getBackendUrl } from "./backend.url";

export const getAllOrders = () => {
  return axios.get(`${getBackendUrl()}/orders`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addOrder = (order) => {
  return axios.put(`${getBackendUrl()}/order`, order, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const addOrderEntry = (id, orderEntry) => {
  return axios.put(`${getBackendUrl()}/order/${id}/entry`, orderEntry, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const removeOrder = (id) => {
  return axios.delete(`${getBackendUrl()}/order/${id}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const removeOrderEntry = (id, orderEntryId) => {
  return axios.delete(`${getBackendUrl()}/order/${id}/entry/${orderEntryId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
};

export const committOrderEntry = (id, orderEntryId, orderEntry) => {
  return axios.post(
    `${getBackendUrl()}/order/${id}/entry/${orderEntryId}/committ`,
    orderEntry,
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const payOrderEntry = (id, orderEntryId) => {
  return axios.post(
    `${getBackendUrl()}/order/${id}/entry/${orderEntryId}/pay`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const publishOrder = (id) => {
  return axios.post(
    `${getBackendUrl()}/order/${id}/publish`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};

export const closeOrder = (id) => {
  return axios.post(
    `${getBackendUrl()}/order/${id}/close`,
    {},
    {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    }
  );
};
